module.exports = __webpack_public_path__ + "img/app-download-google.5a7ac65f.svg";